import React from 'react';

import GridLogAccessi from './../containers/log/GridLogAccessi';


class LogAccessi extends React.Component {    

    render() {
        return (
            <React.Fragment>
                <h2 className={'content-block'}>Log Accessi</h2>

                <GridLogAccessi />
            </React.Fragment>
        );
    }
};


export default LogAccessi;